// #MODULE - Analytics
// > Author: Joseph Acosta
// >
// > Create Date: March 25, 2015

import $ from 'jquery';
import analyticsBase from '@component/common/src/util/AnalyticsBase';
import mcomAnalytics from '../util/Coremetrics';


function linkTagData(modelData, type, name, options) {
  const winObj = (options && options.window) ? options.window : window;
  return {
    href: `${winObj.location.href}/quickbag?cm_sp=quickbag-_-${type}-_-${modelData.meta.totalQuantity}`,
    name,
  };
}

function elementTagData(type) {
  const attrs = [];
  return {
    elementID: type,
    elementCategory: 'quickbag',
    attributes: attrs,
  };
}

function setup() {
  analyticsBase.addListener('QB_MANUAL_LINK_TAG', mcomAnalytics.linkClickTag);
  analyticsBase.addListener('QB_ELEMENT_TAG', mcomAnalytics.elementTag);
}

function tearDown() {
  analyticsBase.removeListener('QB_MANUAL_LINK_TAG', mcomAnalytics.linkClickTag);
  analyticsBase.removeListener('QB_ELEMENT_TAG', mcomAnalytics.elementTag);
}

function fireElementTag(type) {
  const data = elementTagData(type);
  analyticsBase.fireEvent('QB_ELEMENT_TAG', data);
}

function fireManualLinkTag(modelData, type, name, options) {
  const data = linkTagData(modelData, type, name, options);
  analyticsBase.fireEvent('QB_MANUAL_LINK_TAG', data);
}

function fireManualLinkTagForStarRewards() {
  const data = {
    href: '/quickbag?cm_sp=quick_bag-_-notification_message-_-star_rewards',
    name: 'star_rewards',
  };
  analyticsBase.fireEvent('QB_MANUAL_LINK_TAG', data);
}

$(document).ready(setup);
$(window).on('unload', tearDown);

export default {
  setup,
  tearDown,
  fireElementTag,
  fireManualLinkTag,
  fireManualLinkTagForStarRewards,
};
